import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=d60e051e&scoped=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./PhotoUpload.vue?vue&type=style&index=0&id=d60e051e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60e051e",
  null
  
)

export default component.exports